// extracted by mini-css-extract-plugin
export default {"syncButton":"returnButton_syncButton__9ULx1","sender":"returnButton_sender__DzIfB","amount":"returnButton_amount__7hZ12","balance":"returnButton_balance__L2yaJ"};